/**
 * @desc unlocking
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.test.unlocking.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/unlocking`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
